module.exports = __webpack_public_path__ + "img/1727922147434-df283041-3c7c-4379-85f8-0e5b90831a3f.jpeg.3b5b0899.webp";